<form>
  <mat-slide-toggle
    class="scope-ui-toggle"
    [disableRipple]="true"
    [disabled]="isDisabled"
    [ngModel]="value"
    [formControl]="control"
    (change)="onToggle($event.checked)">
    <span [matTooltip]="description">{{ title }}</span>
  </mat-slide-toggle>
</form>
